import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { NewlineToBreakPipe } from "./dialog-message";
import { animate, state, style, transition, trigger } from '@angular/animations';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@Component({
  selector: 'app-dialog-message',
  templateUrl: './dialog-message.component.html',
  styleUrls: ['./dialog-message.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    NewlineToBreakPipe,
],
animations: [
    trigger('dialogAnim', [
      state('void', style({ opacity: 0, transform: 'scale(0.9) translateY(10px)' })),
      state('*',    style({ opacity: 1, transform: 'scale(1) translateY(0)' })),
      transition('void <=> *', animate('220ms cubic-bezier(.25,.8,.25,1)'))
    ])
  ]
})
export class DialogMessageComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}  

  closeDialog(): void {
    this.dialogRef.close();
  }
}
